var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '../typography';
export var TableTitle = function (_a) {
    var title = _a.title, childrenArg = _a.children, tooltip = _a.tooltip, props = __rest(_a, ["title", "children", "tooltip"]);
    var children = childrenArg && typeof childrenArg === 'string' ? childrenArg.toUpperCase() : childrenArg;
    var content = title && title.toUpperCase();
    return (_jsx(Typography, __assign({ type: "secondary", variant: "small", weight: 600, tooltip: tooltip }, { children: content || children }), void 0));
};
